<div class="container-fluid admin-container mb-5 ">
    <div class="row">
        <div class="col-md-12">
            <div class="page-header">
                <div>
                    <p class="page-title"> {{pageTitle}} </p>
                </div>
            </div>
        </div>
    </div>
    <form class="padding-bottum-1em" [formGroup]="deviceTypeForm" (ngSubmit)="onSubmit()" id="deviceTypeForm"
        class="row">
        <div class="col-md-3">
            <div class="form-group">
                <label class="control-label" for="deviceTypeName"><span class="required">*
                    </span>{{resourceKeyValue.lblDeviceTypeName}}</label>
                <input type="text" class="form-control" id="deviceTypeName"
                    placeholder={{resourceKeyValue.deviceTypeNamePlaceholder}} formControlName="deviceTypeName"
                    [class.is-invalid]="deviceTypeForm.controls.deviceTypeName.invalid && deviceTypeForm.controls.deviceTypeName.dirty">
                <div class="invalid-feedback"
                    *ngIf="deviceTypeForm.controls.deviceTypeName.invalid && deviceTypeForm.controls.deviceTypeName.dirty"
                    id="deviceTypeName-validation">
                    <small
                        *ngIf="deviceTypeForm.controls.deviceTypeName.errors.required">{{resourceKeyValue.validationdeviceTypeNameRequired}}</small>
                    <small
                        *ngIf="deviceTypeForm.controls.deviceTypeName.errors.maxlength">{{resourceKeyValue.validationLengthMustbe200Characters}}</small>
                    <small
                        *ngIf="deviceTypeForm.controls.deviceTypeName.errors?.onlyWhiteSpace">{{resourceKeyValue.onlyWhiteSpaceNotAllowed}}</small>
                    <small
                        *ngIf="deviceTypeForm.controls.deviceTypeName.errors?.errorDeviceTypeName">{{resourceKeyValue.validationAlreadyExistDeviceTypeName}}</small>
                </div>
            </div>
        </div>
        <div class="col-md-3">
            <div class="form-group">
                <label class="control-label" for="deviceTypeCode"><span class="required">*
                    </span>{{resourceKeyValue.lblDeviceTypeCode}}</label>
                <input type="text" class="form-control" id="deviceTypeCode"
                    placeholder={{resourceKeyValue.deviceTypeCodePlaceholder}} formControlName="deviceTypeCode"
                    [class.is-invalid]="deviceTypeForm.controls.deviceTypeCode.invalid && deviceTypeForm.controls.deviceTypeCode.dirty">
                <div class="invalid-feedback"
                    *ngIf="deviceTypeForm.controls.deviceTypeCode.invalid && deviceTypeForm.controls.deviceTypeCode.dirty"
                    id="deviceTypeCode-validation">
                    <small
                        *ngIf="deviceTypeForm.controls.deviceTypeCode.errors.required">{{resourceKeyValue.validationdeviceTypeCodeRequired}}</small>
                    <small
                        *ngIf="deviceTypeForm.controls.deviceTypeCode.errors.maxlength">{{resourceKeyValue.validationLengthMustbe50Characters}}</small>
                    <small
                        *ngIf="deviceTypeForm.controls.deviceTypeCode.errors?.onlyWhiteSpace">{{resourceKeyValue.onlyWhiteSpaceNotAllowed}}</small>
                    <small
                        *ngIf="deviceTypeForm.controls.deviceTypeCode.errors?.errorDeviceTypeCode">{{resourceKeyValue.validationAlreadyExistDeviceTypeCode}}</small>
                </div>
            </div>
        </div>
        <div class="col-md-12">
            <div class="table-responsive">
                <table class="table">
                    <thead>
                        <tr>
                            <th scope="col" class="tabfocusable w-10">
                                <label class="control-label"><span class="required">*
                                    </span>{{resourceKeyValue.gridHeaderModelRegex}}</label>

                                <a class="text-primary float-right" (click)="addModelControl();">
                                    <span>
                                        <strong>{{resourceKeyValue.gridHeaderNewRegex}}</strong>
                                    </span>
                                </a>
                            </th>
                            <th scope="col" class="tabfocusable w-10"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr formArrayName="models" *ngFor="let model of models.controls; let i = index">
                            <td scope="row">
                                <div class="form-group">
                                    <input [formControlName]="i" type="text" class="form-control"
                                        [class.is-invalid]="model.invalid && model.dirty">
                                    <div class="invalid-feedback" *ngIf="model.invalid && model.dirty"
                                        id="regex-validation">
                                        <small
                                            *ngIf="model?.errors?.required">{{resourceKeyValue.validationdeviceTypeModelRequired}}</small>
                                        <small
                                            *ngIf="model?.errors?.maxlength">{{resourceKeyValue.validationLengthMustbe500Characters}}</small>
                                        <small
                                            *ngIf="model?.errors?.onlyWhiteSpace">{{resourceKeyValue.onlyWhiteSpaceNotAllowed}}</small>
                                        <small
                                            *ngIf="model?.errors?.errorDeviceTypeModel">{{resourceKeyValue.validationAlreadyExistDeviceTypeModel}}</small>
                                        <small
                                            *ngIf="model?.errors?.errorDeviceTypeModelPattern">{{resourceKeyValue.validationInvalidDeviceTypeModelPattern}}</small>
                                    </div>
                                </div>
                            </td>
                            <td scope="row">
                                <i *ngIf="setDeleteButtonVisibilty(model?.value, model?.disabled)"
                                    (click)="deleteModelControl(i)" class="icon-close-bold-sm"></i>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </form>
    <div class="form-button-fixed">
        <button id="cancelCreateDeviceTypeBtn" class="btn btn-secondary" [routerLink]="['/devicetypes']">
            {{resourceKeyValue.cancel}}
        </button>
        <button id="createDeviceTypeBtn" type="submit" class="btn btn-primary ml-3" form="deviceTypeForm"
            [disabled]="isLoading || !deviceTypeForm.valid || (deviceTypeForm.valid && deviceTypeForm.pristine)">
            {{resourceKeyValue.save}}
        </button>
    </div>
</div>
<app-loader [isLoading]=isLoading></app-loader>